import { useCallback, useRef, useState } from 'react';

export type UseMultiPressRevealOptions = {
  pressCount: number;
  resetMs: number;
};

export type MultiPressAdvance = {
  count: number;
  revealed: boolean;
};

export const advanceMultiPress = (
  count: number,
  pressCount: number,
): MultiPressAdvance =>
  count + 1 >= pressCount
    ? { count: 0, revealed: true }
    : { count: count + 1, revealed: false };

export const useMultiPressReveal = ({
  pressCount,
  resetMs,
}: UseMultiPressRevealOptions) => {
  const [isRevealed, setRevealed] = useState(false);
  const countRef = useRef(0);
  const resetTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const onPress = useCallback(() => {
    if (resetTimeoutRef.current) {
      clearTimeout(resetTimeoutRef.current);
    }
    const { count, revealed } = advanceMultiPress(countRef.current, pressCount);
    countRef.current = count;
    if (revealed) {
      setRevealed(true);
      return;
    }
    resetTimeoutRef.current = setTimeout(() => {
      countRef.current = 0;
    }, resetMs);
  }, [pressCount, resetMs]);

  return { isRevealed, onPress };
};
